export const phone = {
    validate: value => {
        return !(value.match(/^(0|\+41)\d{9}$/) === null)
    }
}
